const trendingNow =  [
    {
        name: "Rampage",
        image: "/assets/movies/rampage.jpg"
    },
    {
        name: "Jurassic World: Dominion",
        image: "/assets/movies/jurassic-world.jpg"
    },
    {
        name: "Aladdin",
        image: "/assets/movies/aladdin.jpg"
    },
    {
        name: "Extraction",
        image: "/assets/movies/extraction.jpg"
    },
    {
        name: "Venom",
        image: "/assets/movies/venom.jpg"
    },
    {
        name: "Tomb Raider",
        image: "/assets/movies/tomb-raider.jpg"
    },
    {
        name: "Robin",
        image: "/assets/movies/robin.jpg"
    },
    {
        name: "Uncharted",
        image: "/assets/movies/uncharted.jpg"
    }
]

export {
    trendingNow
}